// extracted by mini-css-extract-plugin
export default {"main":"Vaccinations_main__yuU1W","ltr":"Vaccinations_ltr__hMTTm","rtl":"Vaccinations_rtl__bzTiI","first":"Vaccinations_first__fmVDp","firstPara":"Vaccinations_firstPara__vdriw"};